<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONVÊNIOS</span>
                </h4>
                <app-tabela
                    :itens="convenios"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="nuValorConvenio" slot-scope="data">
                        <span class="text-nowrap">{{
                            data.nuValorConvenio | currency
                        }}</span>
                    </template>
                    <template slot="vigencia" slot-scope="data">
                        {{
                            data.dtInicioVigencia
                                ? $moment(data.dtInicioVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                        <span v-if="data.dtInicioVigencia">a</span>
                        {{
                            data.dtFimVigencia
                                ? $moment(data.dtFimVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </template>
                    <template slot="situacaoConvenio" slot-scope="data">
                        <app-status
                            :status="data.situacaoConvenio.toUpperCase()"
                        ></app-status>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="permiteAcessoEmissaoDocumentos"
                        >
                            <i
                                class="fa fa-file-o fa-lg icon-button"
                                title="Emissão de Documentos"
                                @click.stop="toEmissaoDocumentos(data)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view :convenio="convenio"></router-view>
    </div>
</template>

<script>
import ConveniosServicos from './ConveniosServicos'

export default {
    components: {},

    data() {
        return {
            convenios: [],
            convenio: null,
            campos: [
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Convênio',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'convenente',
                    label: 'Convenente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcObjeto',
                    label: 'Objeto',
                    filterable: true,
                    tdClass: 'colObjeto'
                },
                {
                    key: 'vigencia',
                    label: 'Vigência'
                },
                {
                    key: 'nuValorConvenio',
                    label: 'Total Convênio',
                    tdClass: 'text-right'
                },
                {
                    key: 'situacaoConvenio',
                    label: 'Situação',
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        obterConvenios() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.convenios = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        toEmissaoDocumentos(conv) {
            this.convenio = conv
            this.$router.push({
                name: 'Convenios_EmissaoDocumentos',
                params: {
                    convenioId: this.convenio.idConvenio
                }
            })
        }
    },

    created() {
        this.obterConvenios()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Convenios'
        },

        permiteAcessoEmissaoDocumentos() {
            return this.$temAcessoView(['CONV-PAREC-FIN-00'])
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'Convenios') {
                if (this.$store.getters.recarregar) {
                    this.obterConvenios()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
